import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../routes/AppRoutes';
import { strings } from '../../resources/strings';
import { SessionHelper } from '../../helpers/SessionHelper';
import { ProfileHelper } from '../../helpers/ProfileHelper';
import { SeparationType } from '../../enums/SeparationType';
import { useAuth } from '../../contexts/AuthContext';
import { Body } from '../../common-components/Layout/Body/Body';
import { Header } from '../../common-components/Layout/Header/Header';
import { Page } from '../../common-components/Layout/Page/Page';
import { ManageOrderBatch } from '../../components/ManageOrderBatch/ManageOrderBatch';

const OrdersWithDegree: React.FC = () => {
  const navigate = useNavigate();
  const { session, signOut } = useAuth();
  const [version, setVersion] = React.useState<number>(1);

  useEffect(() => {
    if (!session || SessionHelper.isExpired(session)) {
      signOut(() => {
        navigate(routes.Login);
      });
      return;
    }
  }, [session, navigate]);

  const headerRender = React.useMemo(() => {
    return (
      <Header
        title={strings.OrderWithDegree}
        breadcrumbItems={[
          {
            text: strings.Home,
            route: routes.Home
          }
        ]}
        separationType={SeparationType.Prescription}
        version={version}
        alertSummary={ProfileHelper.profilesThatCanManageTransport.some(p => p === session?.user?.profileType)}
        reportList={true}
      />
    );
  }, [version, session]);

  return (
    <Page header={headerRender}>
      <Body>
        <ManageOrderBatch
          separationType={SeparationType.Prescription}
          expressOrder={false}
          listingOrders={() => listingOrders()}
        />
      </Body>
    </Page>
  );

  function listingOrders() {
    const newVersion = Date.now();
    setVersion(newVersion);
  }
}

export default OrdersWithDegree;
